import './App.css';
import Home from './components/Home/Home'
import Footer from './components/Footer'

function App() {
  return (
    <div className="App">
      <Home/>
      <Footer/>
    </div>
  );
}

export default App